export default __webpack_public_path__ + "a343569ef877a678c9a783908d536485.png";